import { useParams, useLocation } from 'react-router-dom'
import { SUPPORTED_LOCALES } from '../i18n'

export function useLocalePath() {
  const { lang } = useParams<{ lang: string }>()
  const { pathname } = useLocation()
  const pathLang = pathname.split('/').filter(Boolean)[0]
  const locale = lang ?? (SUPPORTED_LOCALES.includes(pathLang as never) ? pathLang : 'en')
  return (path: string) => `/${locale}${path.startsWith('/') ? path : '/' + path}`
}
